var React = require('react');

function TriangleRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M50.2755 38.1992C51.2415 39.227 51.2415 40.773 50.2755 41.8008L34.0354 59.08C32.2777 60.9503 29 59.7781 29 57.2792V22.7208C29 20.2219 32.2777 19.0497 34.0355 20.92L50.2755 38.1992Z","fill":"currentColor"}));
}

TriangleRightInline.defaultProps = {"width":"1em","height":"1em","viewBox":"0 0 80 80","fill":"none"};

module.exports = TriangleRightInline;

TriangleRightInline.default = TriangleRightInline;
